import { useMemo } from "react";
import { addTokenToUrl } from "../../shared/utils/addTokenToUrl";
import { getAccessToken } from "../../services/api/utils";

export const useServiceUrl = (serviceUrl: string, path?: string): string => {
  const token = getAccessToken();
  const url = useMemo(
    () => addTokenToUrl(serviceUrl, token, path),
    [serviceUrl, token],
  );
  return url;
};
